/***************************************************************************
 * COPYRIGHT (C) 2015, Rapid7 LLC, Boston, MA, USA.
 * 모든 권한 보유. 본 자료에는 * Rapid7의 비공개 독점 정보를
 비롯해 비공개, 저작권 보호 저작물이 포함되었습니다.
 **************************************************************************/

/* jshint maxlen: false */
export default {
  insightvmNavMenus: {
    ftux: {
      back: '뒤로',
      cardLibrary: {
        content: {
          description:
            '고유한 대시보기를 생성해 중요한 통찰력에 중점을 두십시오. ' +
            '이해 관계자들을 위한 맞춤식 보기를 구성하십시오.',
        },
        title: '고유한 보기 생성',
      },
      cards: {
        content: {
          description:
            '포괄적인 필터링 기능을 통해 데이터를 탐색하고 세부 검색하십시오.',
        },
        title: '확장 및 필터링',
      },
      dashboards: {
        content: {
          description:
            '특별히 제작된 대시보드를 통해 요구 사항에 맞는 적절한 정보를 표시해 보십시오.',
        },
        title: '대시보드 라이브러리',
      },
      end: '종료',
      endTour: '투어 종료',
      info: {
        description: '이 메뉴에서 언제든 대시보드 투어에 액세스하십시오.',
      },
      navigation: {
        content: {
          description:
            '직관적인 대시보드 및 시각화를 통해 데이터에 대한 즉각적인 통찰력을 얻으십시오.',
        },
        title: '탐색',
      },
      next: '다음',
      ok: '확인',
      steps: '(__end__ 의 __start__)',
      welcome: {
        content: {
          description:
            '다음 스캔 수일 전 취약점을 보여주며 IT를 통해 취해야 하는 보안 조치의 우선 순위를' +
            '결정하도록 돕는 적응형 워크플로우를 갖춘 실시간 대시보드를 이용해 보십시오.',
          header: '최신 Nexpose 소개',
        },
        dismiss: '무시',
        quickTour: '간단히 투어',
      },
    },
    leftNav: {
      administration: '관리',
      assets: '자산',
      dashboard: '대시보드',
      home: '홈',
      policies: '정책',
      projects: '프로젝트',
      reports: '보고서',
      tickets: '티켓',
      vulnerabilities: '취약점',
    },
    topNav: {
      assetGroup: '자산 그룹',
      changePassword: '암호 변경',
      create: '생성',
      dynamicAssetGroup: '동적 자산 그룹',
      help: '도움말',
      logoff: '로그 오프',
      report: '보고서',
      search: '검색',
      site: '사이트',
      support: '지원',
      tags: '태그',
      tour: '투어',
      userPreferences: '사용자 환경 설정',
    },
  },
};
